import { filter, mergeMap } from 'rxjs/operators';

import { RootEpic } from '../../../store/epics';
import { ErrorType } from '../../../store/reducers/common';
import { recordOfferConsent, recordConsentFail, recordConsentSuccess } from '../reducers/consent';

export const recordOfferConsentEpic: RootEpic = (action$, state$, { api }) =>
  action$.pipe(
    filter(recordOfferConsent.match),
    mergeMap(({ payload: { offerId, onSuccess } }) =>
      api.consent
        .recordOfferConsent(offerId)
        .then(() => [recordConsentSuccess(), ...onSuccess])
        .catch((error: ErrorType) => [recordConsentFail(error)]),
    ),
    mergeMap((action) => action),
  );
